import React from "react";
import "./common-action.css";
import { ResourceRoute } from "../../../resource-routing";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import * as contactAction from "../../../../../action/contactAction";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
class NewsHeadings extends React.Component {
  handleChange(e) {
    var val = e.target.value;
    val = val.replace(/^\s+/, "");
    this.setState({
      email: val,
    });
  }

  constructor(props) {
    super(props);
    this.state = {
      subscribeNow: false,
      description: "",
      buttondDetail: "",
      // buttondDetail_2: "",
      categoryType: "",
      email: "",
      emailErr: "",
      newDetail: false,
    };
  }
  showSubscribe = () => {
    this.setState({ subscribeNow: true });
  };

  //  this.setState({subscribeNow : true})
  render() {
    return (
      <div className="news-heading">
        <div className="main-head-1">
          <h4>
            <span className="primary-span">IONIXX TECH NEXUS</span>
          </h4>
          {this.props.newDetail ? (
            <em
              className={
                this.props.categoryType === "fintech"
                  ? "new-category fintech"
                  : "new-category" && this.props.categoryType === "web3"
                  ? "new-category web3"
                  : "new-category" && this.props.categoryType === "design"
                  ? "new-category design"
                  : "new-category" && this.props.categoryType === "healthtech"
                  ? "new-category healthtech"
                  : "new-category"
              }
            >
              {this.props.buttondDetail}
            </em>
          ) : (
            ""
          )}
          <p>
            {this.props.description}

            {/* Healthcare Providers Continue to Adapt
                        to Changing Care Environments | HealthTech Magazine */}
          </p>
        </div>
        <Link to={ResourceRoute.NEW_NEWSLETTER} className="to-newsfeed">
          <img
            src="/assets/newsletter_images/back-arrow.png"
            alt="back to new"
          ></img>
          Newsletter
        </Link>
        {this.props.newDetail ? (
          ""
        ) : (
          <button
            className={
              this.props.categoryType === "fintech"
                ? "selected-news-heading fintech"
                : "selected-news-heading" && this.props.categoryType === "web3"
                ? "selected-news-heading web3"
                : "selected-news-heading" &&
                  this.props.categoryType === "design"
                ? "selected-news-heading design"
                : "selected-news-heading" &&
                  this.props.categoryType === "healthtech"
                ? "selected-news-heading healthtech"
                : "selected-news-heading"
            }
          >
            {this.props.buttondDetail}
          </button>
        )}

        <div className="inspired-newsletter mob-news-letter">
          <p>Stay inspired with our newsletter</p>

          <button onClick={this.showSubscribe}>Subscribe</button>
          {this.state.subscribeNow && (
            <div className="subscribe-our-news">
              <div className="form-group newsletter-form-group">
                <input
                  type="text"
                  className="form-control"
                  id=""
                  placeholder="Enter your email*"
                  name={"email"}
                  value={this.state.email}
                  onChange={this.handleChange.bind(this)}
                ></input>
                <div
                  className="newsletter-arrow"
                  onClick={() => {
                    var emailRegx =
                      /^(([a-zA-Z\d-_.]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
                        this.state.email
                      );
                    if (emailRegx === false) {
                      this.setState({
                        emailErr: "Invalid Email",
                      });
                    } else {
                      this.props
                        .subscribeForNewsLetter({
                          emailID: this.state.email,
                          name: this.state.name,
                          category: this.props.category,
                          url: this.props.location.pathname,
                        })
                        .then((res) => {})
                        .catch((err) => {
                          console.log(err);
                        });
                      this.props
                        .sendNewsFeed(this.state.email)
                        .then((res) => {
                          this.setState({
                            email: "",
                            emailErr: "",
                          });
                          if (res.status === 200) {
                            this.props.history.push({
                              pathname: ROUTES.TOAST,
                              contactDetails: false,
                              subscribeDetails: true,
                              pdfDownload: false,
                            });
                          }
                        })
                        .catch((err) => {
                          console.log(err);
                        });
                    }
                  }}
                >
                  <button>
                    <img src="/assets/newsletter_images/right-arrow.svg" />
                  </button>
                </div>
              </div>
              {this.state.emailErr.length > 0 ? (
                <div className="err-msg">
                  <span>{this.state.emailErr}</span>
                </div>
              ) : (
                ""
              )}
            </div>
          )}

          <ul>
            <li>
              <a href="https://www.facebook.com/ionixxtech/" target="_blank">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_179_7027)">
                    <path
                      d="M13.397 20.9972V12.8012H16.162L16.573 9.59217H13.397V7.54817C13.397 6.62217 13.655 5.98817 14.984 5.98817H16.668V3.12717C15.8487 3.03936 15.0251 2.99696 14.201 3.00017C11.757 3.00017 10.079 4.49217 10.079 7.23117V9.58617H7.33203V12.7952H10.085V20.9972H13.397Z"
                      fill="#007CC1"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_179_7027">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://twitter.com/IonixxTech" target="_blank">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_179_7031)">
                    <path
                      d="M19.633 7.99656C19.646 8.17156 19.646 8.34556 19.646 8.51956C19.646 13.8446 15.593 19.9806 8.186 19.9806C5.904 19.9806 3.784 19.3196 2 18.1716C2.324 18.2086 2.636 18.2216 2.973 18.2216C4.78599 18.2259 6.54765 17.6197 7.974 16.5006C7.13342 16.4853 6.31858 16.208 5.64324 15.7073C4.9679 15.2066 4.46578 14.5075 4.207 13.7076C4.456 13.7446 4.706 13.7696 4.968 13.7696C5.329 13.7696 5.692 13.7196 6.029 13.6326C5.11676 13.4484 4.29647 12.9539 3.70762 12.2332C3.11876 11.5126 2.79769 10.6102 2.799 9.67955V9.62956C3.336 9.92856 3.959 10.1156 4.619 10.1406C4.06609 9.77314 3.61272 9.27458 3.29934 8.68935C2.98596 8.10411 2.82231 7.45041 2.823 6.78656C2.823 6.03856 3.022 5.35256 3.371 4.75456C4.38314 5.99958 5.6455 7.01811 7.07634 7.7442C8.50717 8.47031 10.0746 8.88776 11.677 8.96955C11.615 8.66955 11.577 8.35855 11.577 8.04656C11.5767 7.51752 11.6807 6.99361 11.8831 6.5048C12.0854 6.01598 12.3821 5.57183 12.7562 5.19774C13.1303 4.82366 13.5744 4.52697 14.0632 4.32463C14.5521 4.1223 15.076 4.01829 15.605 4.01856C16.765 4.01856 17.812 4.50454 18.548 5.29056C19.4498 5.11616 20.3145 4.78698 21.104 4.31755C20.8034 5.24837 20.1738 6.03766 19.333 6.53756C20.1328 6.44633 20.9144 6.23601 21.652 5.91356C21.1011 6.71665 20.4185 7.4209 19.633 7.99656Z"
                      fill="#007CC1"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_179_7031">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/ionixx-technologies"
                target="_blank"
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g clip-path="url(#clip0_179_7034)">
                    <path
                      d="M5.73944 7.71325C6.81552 7.71325 7.68786 6.84091 7.68786 5.76483C7.68786 4.68874 6.81552 3.81641 5.73944 3.81641C4.66335 3.81641 3.79102 4.68874 3.79102 5.76483C3.79102 6.84091 4.66335 7.71325 5.73944 7.71325Z"
                      fill="#007CC1"
                    />
                    <path
                      d="M9.52807 9.18902V19.9988H12.8844V14.6532C12.8844 13.2426 13.1497 11.8766 14.8987 11.8766C16.6236 11.8766 16.645 13.4893 16.645 14.7422V19.9997H20.0031V14.0717C20.0031 11.1597 19.3761 8.92188 15.9726 8.92188C14.3386 8.92188 13.2432 9.81861 12.7953 10.6673H12.7499V9.18902H9.52807ZM4.05859 9.18902H7.42024V19.9988H4.05859V9.18902Z"
                      fill="#007CC1"
                    />
                  </g>
                  <defs>
                    <clipPath id="clip0_179_7034">
                      <rect width="24" height="24" fill="white" />
                    </clipPath>
                  </defs>
                </svg>
              </a>
            </li>
            <li>
              <a href="https://www.instagram.com/ionixxtech/" target="_blank">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M21.9916 7.10643C21.9655 6.90388 21.939 6.70133 21.9126 6.49908C21.8901 6.37977 21.8673 6.26046 21.8448 6.14116C21.8363 6.12493 21.8306 6.1087 21.83 6.09308C21.7835 5.94131 21.7376 5.78985 21.691 5.63809C21.6346 5.49474 21.5778 5.35169 21.5213 5.20835C21.4679 5.10106 21.4147 4.99378 21.3616 4.88649C21.3328 4.8342 21.3039 4.78221 21.2754 4.72992C21.1736 4.57305 21.0721 4.41588 20.9706 4.259C20.9427 4.24338 20.9244 4.22054 20.916 4.18958C20.8163 4.06818 20.7169 3.94646 20.6172 3.82505C20.5743 3.77787 20.531 3.73099 20.4881 3.68381C20.3611 3.5615 20.234 3.43949 20.107 3.31718C20.0851 3.29885 20.0632 3.28051 20.0413 3.26248C19.8815 3.14197 19.7218 3.02177 19.562 2.90156C19.4134 2.8111 19.2647 2.72095 19.1161 2.63049C18.9662 2.56047 18.8164 2.49015 18.6666 2.41983C18.5041 2.36122 18.3414 2.30262 18.1786 2.24402C17.8011 2.14455 17.4234 2.04718 17.0312 2.02314C17.0261 2.02284 17.0219 2.00811 17.0174 2H5.92254C5.71204 2.07723 5.48593 2.07303 5.27003 2.12351C5.11808 2.16318 4.96644 2.20315 4.8145 2.24282C4.47878 2.36573 4.14967 2.50307 3.83017 2.66355C3.69864 2.74379 3.56712 2.82372 3.4356 2.90396C3.41638 2.91598 3.39686 2.9283 3.37734 2.94033C3.23681 3.04821 3.09628 3.1558 2.95574 3.26368C2.92361 3.29193 2.89118 3.31988 2.85905 3.34813C2.77678 3.45872 2.63444 3.5026 2.55877 3.6204C2.49391 3.7334 2.38971 3.80853 2.29512 3.89267C2.25308 4.01017 2.1645 4.09312 2.08192 4.18057C2.06601 4.20521 2.05039 4.22985 2.03448 4.2545C1.92667 4.38883 1.86722 4.55832 1.73059 4.67132C1.72398 4.7771 1.66513 4.85884 1.60717 4.94088C1.57564 5.00489 1.57234 5.08664 1.49487 5.1224C1.46724 5.30481 1.37445 5.46319 1.30779 5.63118C1.22791 5.94282 1.14804 6.25445 1.06816 6.56639C1.05555 6.67428 1.04294 6.78217 1.03033 6.89005C1.02012 7.06015 1.00991 7.23024 1 7.40064V17.3006C1.0003 17.45 1.0003 17.5997 1.0006 17.7493C1.01021 17.8698 1.01982 17.9906 1.02943 18.1111C1.06006 18.3107 1.09069 18.5099 1.12131 18.7095C1.14804 18.7458 1.15405 18.787 1.15074 18.8309C1.15405 18.9226 1.22822 18.9959 1.21921 19.0908C1.26575 19.2303 1.34743 19.3598 1.33662 19.5149C1.44832 19.6808 1.54321 19.8542 1.58045 20.0537C1.71678 20.1808 1.77053 20.3608 1.87172 20.5105C1.94229 20.5934 2.00445 20.6818 2.05129 20.7807C2.08102 20.8203 2.13417 20.8399 2.14678 20.894C2.25638 21.0241 2.36599 21.1539 2.47559 21.284C2.51042 21.3096 2.54856 21.3321 2.55877 21.3793C2.57198 21.4048 2.57889 21.4436 2.59961 21.4541C2.84044 21.5752 2.99418 21.8051 3.21729 21.9467C3.28185 21.9876 3.32449 22.0588 3.40407 22.0768C3.50196 22.1216 3.59204 22.1784 3.67492 22.2472C3.73558 22.261 3.78272 22.2986 3.82987 22.3362C3.99743 22.4188 4.16468 22.5014 4.33194 22.5844C4.41362 22.588 4.48268 22.6247 4.54965 22.6664C4.64814 22.6679 4.72261 22.7367 4.813 22.7599C4.96944 22.7833 5.12079 22.8275 5.27093 22.8759C5.48803 22.9171 5.70544 22.9585 5.92254 23H6.1925C6.24234 22.9558 6.29249 22.9558 6.34234 23H16.6874C16.7375 22.9558 16.7874 22.9558 16.8375 23H16.9273C17.0916 22.951 17.2624 22.9537 17.4306 22.9366C17.509 22.8996 17.5936 22.8918 17.678 22.8843C17.845 22.8413 18.0122 22.7987 18.1792 22.756C18.2564 22.7121 18.341 22.6899 18.426 22.6688C18.5263 22.6304 18.6263 22.5919 18.7263 22.5537C18.8509 22.4813 18.9752 22.4086 19.1137 22.3647C19.202 22.3148 19.2899 22.2649 19.3779 22.215C19.4131 22.1751 19.4551 22.1459 19.5067 22.1315C19.6578 22.0212 19.8088 21.9112 19.9599 21.8012C20.1376 21.6383 20.3151 21.4755 20.4929 21.3126C20.6433 21.1335 20.7935 20.9547 20.9439 20.7759C21.0283 20.6514 21.0904 20.5102 21.2133 20.4146C21.225 20.2956 21.3048 20.21 21.3616 20.1132C21.3811 20.0747 21.4006 20.0363 21.4205 19.9978C21.4304 19.978 21.4403 19.9581 21.4502 19.9383C21.4589 19.8734 21.4817 19.8178 21.5439 19.7862C21.5364 19.6835 21.5928 19.6014 21.6322 19.514C21.7024 19.294 21.7727 19.074 21.843 18.8543C21.855 18.796 21.8667 18.738 21.8787 18.68C21.9066 18.5283 21.9345 18.3765 21.9625 18.2247C21.9745 18.0667 21.9862 17.9086 21.9982 17.7502C21.9988 17.6 21.9994 17.4497 22 17.2994V7.39943C21.9973 7.30176 21.9943 7.2041 21.9916 7.10643ZM20.2199 10.5648C20.2196 11.314 20.2175 12.0632 20.2172 12.8124C20.2169 13.5565 20.2178 14.3006 20.2178 15.0449C20.2175 15.939 20.2169 16.833 20.2154 17.7271C20.2154 17.7454 20.2052 17.7637 20.1998 17.7824C20.1977 18.0709 20.1437 18.3498 20.0464 18.6208C20.0509 18.665 20.0289 18.7011 20.0106 18.7383C19.9821 18.8594 19.9407 18.9751 19.871 19.0791C19.704 19.4794 19.4599 19.8265 19.1491 20.1273C18.9002 20.4011 18.6029 20.61 18.2765 20.7798C18.1846 20.8456 18.081 20.8873 17.9759 20.9255C17.9195 20.9538 17.8648 20.9862 17.7996 20.991C17.6657 21.0532 17.5279 21.1016 17.3795 21.1145C17.2862 21.1605 17.1853 21.1668 17.0841 21.1734C16.7291 21.2417 16.3697 21.2227 16.0118 21.2236C15.2526 21.2251 14.4932 21.2245 13.7341 21.2239C12.9849 21.2233 12.2354 21.2212 11.4862 21.2212C10.737 21.2212 9.98747 21.2236 9.23827 21.2236C8.38396 21.2236 7.52996 21.2224 6.67565 21.2194C6.53242 21.2188 6.38768 21.2483 6.24595 21.2032C6.1979 21.2002 6.15016 21.1972 6.10211 21.1942C6.05016 21.1957 5.99641 21.2089 5.94957 21.1725C5.83426 21.1767 5.72435 21.1485 5.61565 21.1133C5.39675 21.0752 5.19015 21.0003 4.99196 20.9003C4.88416 20.8669 4.78327 20.8191 4.69348 20.7497C4.55325 20.6992 4.43254 20.6193 4.33314 20.5078C4.30792 20.5177 4.30732 20.4976 4.30191 20.4829C4.1821 20.4498 4.10613 20.3581 4.02355 20.2749C3.91094 20.2193 3.83858 20.1219 3.76441 20.0261C3.62928 19.8788 3.50016 19.7267 3.40377 19.5497C3.39115 19.5308 3.37824 19.5119 3.36533 19.4929C3.28035 19.382 3.21279 19.2615 3.16654 19.1293C3.07946 18.9797 3.0119 18.8222 2.97796 18.6518C2.95334 18.6368 2.95454 18.6133 2.95695 18.589C2.9074 18.464 2.86626 18.3368 2.86566 18.2001C2.82302 18.1151 2.83023 18.0231 2.83083 17.9323C2.79329 17.8341 2.8032 17.7316 2.8074 17.6297C2.8059 16.9205 2.8035 16.2113 2.8032 15.502C2.8026 14.153 2.8032 12.8043 2.8038 11.4552C2.8044 10.0515 2.8059 8.64779 2.808 7.24376C2.808 7.18516 2.8017 7.12386 2.83113 7.06826C2.83353 6.99523 2.81731 6.9195 2.86025 6.85159C2.90049 6.5132 3.00349 6.19405 3.16144 5.89263C3.26954 5.63779 3.39776 5.39587 3.60916 5.20865C3.63558 5.08603 3.73798 5.02052 3.81485 4.93547C3.88512 4.84412 3.9719 4.76989 4.06409 4.70137C4.14517 4.61903 4.23075 4.54209 4.33615 4.49101C4.44995 4.38612 4.58178 4.31009 4.72201 4.24759C4.74123 4.23767 4.76075 4.22805 4.78026 4.21813C4.87275 4.15202 4.97425 4.10394 5.08385 4.07389C5.26402 3.98493 5.4541 3.92723 5.65199 3.89447C5.71024 3.87133 5.7688 3.8512 5.83276 3.86112C5.83936 3.853 5.84687 3.8515 5.85588 3.85691C5.97509 3.81965 6.09761 3.80372 6.22252 3.80582C6.55223 3.80462 6.88225 3.80342 7.21196 3.80222C7.52185 3.80252 7.83174 3.80282 8.14163 3.80282H10.8099C11.1 3.80282 11.3898 3.80282 11.6799 3.80222C12.3666 3.80041 13.0534 3.79741 13.7401 3.79711C14.1929 3.79711 14.6458 3.80161 15.0986 3.80402C15.4682 3.80372 15.8379 3.80312 16.2075 3.80282C16.4601 3.79831 16.7129 3.78028 16.964 3.82656C17.0946 3.82986 17.2231 3.84699 17.3471 3.89117C17.454 3.90259 17.5582 3.92483 17.654 3.97652C17.8762 4.03872 18.0942 4.11115 18.2852 4.24638C18.4591 4.32241 18.6209 4.41648 18.7542 4.55442C18.8116 4.56463 18.8539 4.59438 18.875 4.65028C19.047 4.73142 19.1437 4.8928 19.271 5.02142C19.3026 5.03314 19.3221 5.05448 19.3266 5.08844C19.4644 5.22818 19.5899 5.37634 19.6587 5.56446C19.7968 5.70811 19.8662 5.88872 19.9304 6.07234C20.0548 6.29713 20.1019 6.54566 20.1361 6.79509C20.1436 6.84828 20.1785 6.89366 20.1692 6.94835C20.2085 7.04362 20.1986 7.14399 20.1992 7.24346C20.2346 7.59086 20.2178 7.93947 20.219 8.28747C20.2217 9.04658 20.2205 9.80569 20.2199 10.5648Z"
                    fill="#007CC1"
                  />
                  <path
                    d="M18.5635 6.69487C18.5635 7.38907 18.0011 7.95195 17.3071 7.95195C16.6132 7.95195 16.051 7.38907 16.051 6.69487C16.051 6.00067 16.6135 5.4375 17.3071 5.4375C18.0008 5.4375 18.5635 6.00037 18.5635 6.69487Z"
                    fill="#007CC1"
                  />
                  <path
                    d="M11.5001 7.28125C8.61974 7.28125 6.28503 9.61779 6.28503 12.5001C6.28503 15.3824 8.61974 17.7192 11.5001 17.7192C14.3804 17.7192 16.7148 15.3824 16.7148 12.5001C16.7148 9.61779 14.3801 7.28125 11.5001 7.28125ZM11.5001 16.0937C9.51668 16.0937 7.90927 14.4847 7.90927 12.5001C7.90927 10.5154 9.51668 8.90646 11.5001 8.90646C13.4834 8.90646 15.0905 10.5154 15.0905 12.5001C15.0905 14.4847 13.4831 16.0937 11.5001 16.0937Z"
                    fill="#007CC1"
                  />
                </svg>
              </a>
            </li>
          </ul>
        </div>
      </div>
    );
  }
}
const mapStateToProps = (state, ownProps) => {
  return state.commonReducer;
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(contactAction, dispatch);
};

export default connect(mapStateToProps, mapDispatchToProps)(NewsHeadings);

// export default NewsHeadings;
